import type Model from "@ember-data/model";
import { service } from "@ember/service";
import Modifier from "ember-modifier";
import type JournalEventModel from "parog-web/models/journal-event";
import type SemeiaSessionService from "parog-web/services/session";

export const alertingStyleClassName = "alerting-style-class";
export const alertingStyleClassNameBlack = "black";

interface Signature {
  Element: HTMLElement;
  Args: {
    Named: { code?: string; style?: string };
    Positional: [JournalEventModel | undefined];
  };
}

export default class AlertingJeStyleModifier extends Modifier<Signature> {
  @service declare session: SemeiaSessionService;

  override modify(element: HTMLElement, [journalEvent], { code, style }): void {
    if (!this.session.medic) return;

    if (journalEvent?.isAlertingJournalEvent) {
      const isBioExam =
        (journalEvent.constructor as typeof Model).modelName ===
        "bio-exam-results-received-journal-event";
      const isBloodPressure =
        (journalEvent.constructor as typeof Model).modelName ===
        "blood-pressure-session-started-journal-event";

      // If it is a BioExamResult or a BloorPressure then we have to check for the corresponding code
      if (isBioExam && !journalEvent.hasAlertForCode(code)) return;
      if (isBloodPressure && !journalEvent.hasAlertForCode(code)) return;

      element.classList.add(alertingStyleClassName);
      if (style == "black") {
        element.classList.add(alertingStyleClassNameBlack);
      }
    }
  }
}
